import { Seo } from "@/components/seo";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { SignInForm } from "@/features/sign-in/components/sign-in.form";

export function SignIn() {
  const searchParams = new URLSearchParams(location.search);
  const confirmed = searchParams.get("confirmed");

  return (
    <div>
      <Seo title="Sign In" />
      <div className="px-4 sm:px-6">
        <p className="text-lg font-medium text-foreground">Welcome Back</p>
        <p className="mb-6 text-base font-normal text-muted">
          Sign into your account to continue
        </p>
        {confirmed && (
          <Alert variant="success" className="mb-6">
            <AlertTitle>Email confirmed</AlertTitle>
            <AlertDescription>
              Your email has been confirmed. You can now sign in to your
              account.
            </AlertDescription>
          </Alert>
        )}
        <div className="mb-8 sm:mb-11">
          <SignInForm />
        </div>
      </div>
      {/* <div className="p-1">
        <div className="rounded-md border border-border bg-card p-3">
          <p className="text-center text-sm font-normal text-muted">
            Don't have an account?{" "}
            <Button variant="link" className="h-auto p-0" asChild>
              <Link to="/sign-up/welcome">Sign up</Link>
            </Button>
          </p>
        </div>
      </div> */}
    </div>
  );
}
